import { getActionType, TYPES } from '../util/redux';
import { WorkType, PAGESIZE } from '../action/mv';
// 分tab分页数据存储
const initState = {
    request0: false,
    request1: false,
    delrequest: false,
    tryrequest: false,
    querylsrequest: false,
    msg0: '',
    msg1: '',
    data0: {
        total: 0,
        page: 1
    },
    data1: {
        total: 0,
        page: 1
    },
};
const type1 = getActionType(WorkType, 'request0');
const type2 = getActionType(WorkType, 'success');
const type3 = getActionType(WorkType, 'fail');
const type4 = getActionType(WorkType, 'clear');
const type5 = getActionType(WorkType, 'request1');
const type7 = getActionType(WorkType, 'delrequest');
const type8 = getActionType(WorkType, 'delcomplete');
const type9 = getActionType(WorkType, 'savepage');
const type10 = getActionType(WorkType, 'tryrequest');
const type11 = getActionType(WorkType, 'trycomplete');
const type12 = getActionType(WorkType, 'clearsgtab');
const type13 = getActionType(WorkType, 'edititem');
const type14 = getActionType(WorkType, 'querylistrequest');
const type15 = getActionType(WorkType, 'queryliststatus');

// 删除列表后的操作
const disposeAfterDel = function ({ data, page, list }) {
    // 可能存在当前页被删光
    if (list.length > 0) {
        data[page] = list;
    } else {
        // 删光,如果在最后一页则往前翻一页，页数更改;
        // 如果不是最后一页则往后翻一页，整体数组往前挪一位;
        const maxPage = Math.ceil(data.total / PAGESIZE);
        if (page == maxPage) {
            delete data[page];
            data.page = page - 1;
        } else {
            const curNewData = {};
            for (const p in data) {
                const n = parseInt(p, 10);
                if (!isNaN(n) && n > page) {
                    curNewData[n - 1] = data[n];
                } else if (n != page) {
                    curNewData[p] = data[p];
                }
            }
            data = curNewData;
        }
    }
    return data;
};
// 0 已发布, 1 发布中, 2 已锁定
export default function mvReducer(state = initState, action) {
    const { type, payload } = action;
    switch (type) {
        case type1:
            // 清空数据
            let qlrData = state.data0;
            if (payload._clear) {
                qlrData = {};
            }
            return {
                ...state,
                request0: true,
                msg0: '',
                data0: qlrData
            };
        case type5:
            return {
                ...state,
                request1: true,
                msg1: '',
                data1: {
                    ...state.data1
                }
            };
        case type2:
            delete payload.code;
            const status = payload._status;
            const page = payload._page;
            const list = payload.data;
            const showExposure = payload.showExposure;
            const total = payload.total;
            const odata = state[`data${status}`];
            odata[page] = list;
            odata.total = total;
            odata.showExposure = showExposure;
            // 测试
            // if(status == 1){
            //     list[0].uploadStatus = -1;
            // }
            return {
                ...state,
                [`request${status}`]: false,
                [`msg${status}`]: '',
                [`data${status}`]: odata
            };
        case type3:
            const cstatus = payload._status;
            const rcode = payload.code;
            const rmsg = payload.msg;
            return {
                ...state,
                [`request${cstatus}`]: false,
                [`msg${cstatus}`]: rmsg
            };
        case type7:
            return {
                ...state,
                delrequest: true,
            };
        case type8: // 删除视频
            const { success } = payload;
            // let newData = {};
            if (success) {
                const npage = payload.page;
                const nstatus = payload.status;
                const nId = payload.videoId;
                let ndata = state[`data${nstatus}`];
                const nlist = ndata[npage];
                for (let i = 0, len = nlist.length; i < len; i++) {
                    if (nlist[i].videoId == nId) {
                        nlist.splice(i, 1);
                        break;
                    }
                }
                ndata.total -= 1;
                ndata = disposeAfterDel({
                    list: nlist,
                    data: ndata,
                    page: npage
                });
                return {
                    ...state,
                    delrequest: false,
                    [`data${nstatus}`]: ndata
                };
            }
            return {
                ...state,
                delrequest: false
            };
        case type9: // 保存page,且清空msg
            const spage = payload.page;
            const sstatus = payload.status;
            const sdata = state[`data${sstatus}`];
            sdata.page = spage;
            return {
                ...state,
                [`msg${sstatus}`]: '',
                [`data${sstatus}`]: sdata
            };
        case type10: // 请求重新发布
            return {
                ...state,
                tryrequest: true
            };
        case type11: // 重新发布处理
            const trySucc = payload.success;
            if (trySucc) {
                const typage = payload.page;
                const tystatus = payload.status;
                const tyId = payload.videoId;
                const tydata = state[`data${tystatus}`];
                const tylist = tydata[typage];
                // 上传状态设置为发布中
                for (let i = 0, len = tylist.length; i < len; i++) {
                    if (tylist[i].videoId == tyId) {
                        tylist[i].uploadStatus = 0;
                        break;
                    }
                }
                return {
                    ...state,
                    tryrequest: false,
                    [`data${tystatus}`]: tydata
                };
            }
            return {
                ...state,
                tryrequest: false
            };
        case type12: // 清除单个tab的数据
            const tbStatus = payload;
            return {
                ...state,
                [`data${tbStatus}`]: {
                    total: 0,
                    page: 1
                }
            };
        case type13: // 修改视频信息,需要完成歌曲信息,bgms列表不展示暂时不处理
            const edProps = ['tagList', 'description', 'title', 'coverIdStr', 'coverUrl'];
            const edVideoId = payload.videoId;
            const edStatus = 0;
            const edData = state[`data${edStatus}`];
            const edpage = edData.page;
            const edList = edData[edpage];
            // 找出对应视频并修改
            if (edList && edList.length) {
                for (let i = 0, len = edList.length; i < len; i++) {
                    if (edList[i].videoId == edVideoId) {
                        for (let k = 0, len = edProps.length; k < len; k++) {
                            edList[i][edProps[k]] = payload[edProps[k]];
                        }
                    }
                }
            }
            return {
                ...state,
                [`data${edStatus}`]: edData
            };
        case type14: //
            return {
                ...state,
                querylsrequest: true
            };
        case type15: // tab=1中去除已经转码成功的视频
            const qlsSucc = payload.success;
            if (qlsSucc) {
                const qlsData = payload.data;
                const taboPage = payload.page;
                let taboData = state.data1;
                let taboList = taboData[taboPage];
                let delCount = 0;
                for (let i = 0, len = taboList.length; i < len; i++) {
                    if (qlsData[taboList[i].videoId] == 1) {
                        taboList[i] = 'null'; // 不改变数据先处理这样
                        delCount++;
                    } else if (qlsData[taboList[i].videoId] == -1) {
                        taboList[i].uploadStatus = -1;
                    }
                }
                taboList = taboList.filter((item, n) => item != 'null');
                taboData.total -= delCount;
                taboData = disposeAfterDel({
                    data: taboData,
                    page: taboPage,
                    list: taboList
                });
                return {
                    ...state,
                    querylsrequest: false,
                    data1: taboData
                };
            }
            return {
                ...state,
                querylsrequest: false
            };
        case TYPES.CLEAR_ALL: case type4:
            return {
                ...initState
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./client/reducers/mv.js